/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiUserColumnsRequest,
    ApiUserColumnsRequestFromJSON,
    ApiUserColumnsRequestToJSON,
    ApiUserColumnsResponse,
    ApiUserColumnsResponseFromJSON,
    ApiUserColumnsResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    UserRequest,
    UserRequestFromJSON,
    UserRequestToJSON,
    UserResponse,
    UserResponseFromJSON,
    UserResponseToJSON,
    UsersResponse,
    UsersResponseFromJSON,
    UsersResponseToJSON,
} from '../models';

export interface CreateUserRequest {
    userRequest: UserRequest;
}

export interface DeleteUserRequest {
    id: string;
}

export interface GetListOfDeviceColumnsRequest {
    id: string;
}

export interface GetListOfRuleColumnsRequest {
    id: string;
}

export interface GetListOfStbgroupColumnsRequest {
    id: string;
}

export interface ReadUserRequest {
    id: string;
}

export interface ReadUsersRequest {
    filter?: string | null;
    orderBy?: string | null;
    direction?: ReadUsersDirectionEnum;
    offset?: number | null;
    limit?: number | null;
}

export interface UpdateListOfDeviceColumnsRequest {
    id: string;
    apiUserColumnsRequest: ApiUserColumnsRequest | null;
}

export interface UpdateListOfRuleColumnsRequest {
    id: string;
    apiUserColumnsRequest: ApiUserColumnsRequest | null;
}

export interface UpdateListOfStbgroupColumnsRequest {
    id: string;
    apiUserColumnsRequest: ApiUserColumnsRequest | null;
}

export interface UpdateUserRequest {
    id: string;
    userRequest: UserRequest;
}

export interface UpdateUserIsLockedRequest {
    id: string;
    body: boolean;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Create a new user.
     */
    async createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.userRequest === null || requestParameters.userRequest === undefined) {
            throw new runtime.RequiredError('userRequest','Required parameter requestParameters.userRequest was null or undefined when calling createUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserRequestToJSON(requestParameters.userRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new user.
     */
    async createUser(requestParameters: CreateUserRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete user by ID.
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user by ID.
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of device columns for user.
     */
    async getListOfDeviceColumnsRaw(requestParameters: GetListOfDeviceColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUserColumnsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListOfDeviceColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/deviceColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserColumnsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of device columns for user.
     */
    async getListOfDeviceColumns(requestParameters: GetListOfDeviceColumnsRequest, initOverrides?: RequestInit): Promise<ApiUserColumnsResponse> {
        const response = await this.getListOfDeviceColumnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of rule columns for user.
     */
    async getListOfRuleColumnsRaw(requestParameters: GetListOfRuleColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUserColumnsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListOfRuleColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/ruleColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserColumnsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of rule columns for user.
     */
    async getListOfRuleColumns(requestParameters: GetListOfRuleColumnsRequest, initOverrides?: RequestInit): Promise<ApiUserColumnsResponse> {
        const response = await this.getListOfRuleColumnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of stbgroup columns for user.
     */
    async getListOfStbgroupColumnsRaw(requestParameters: GetListOfStbgroupColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUserColumnsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListOfStbgroupColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/stbgroupColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserColumnsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of stbgroup columns for user.
     */
    async getListOfStbgroupColumns(requestParameters: GetListOfStbgroupColumnsRequest, initOverrides?: RequestInit): Promise<ApiUserColumnsResponse> {
        const response = await this.getListOfStbgroupColumnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read user by ID.
     */
    async readUserRaw(requestParameters: ReadUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Read user by ID.
     */
    async readUser(requestParameters: ReadUserRequest, initOverrides?: RequestInit): Promise<UserResponse> {
        const response = await this.readUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read users.
     */
    async readUsersRaw(requestParameters: ReadUsersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UsersResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersResponseFromJSON(jsonValue));
    }

    /**
     * Read users.
     */
    async readUsers(requestParameters: ReadUsersRequest = {}, initOverrides?: RequestInit): Promise<UsersResponse> {
        const response = await this.readUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update list of device columns for user.
     */
    async updateListOfDeviceColumnsRaw(requestParameters: UpdateListOfDeviceColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListOfDeviceColumns.');
        }

        if (requestParameters.apiUserColumnsRequest === null || requestParameters.apiUserColumnsRequest === undefined) {
            throw new runtime.RequiredError('apiUserColumnsRequest','Required parameter requestParameters.apiUserColumnsRequest was null or undefined when calling updateListOfDeviceColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/deviceColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserColumnsRequestToJSON(requestParameters.apiUserColumnsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update list of device columns for user.
     */
    async updateListOfDeviceColumns(requestParameters: UpdateListOfDeviceColumnsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateListOfDeviceColumnsRaw(requestParameters, initOverrides);
    }

    /**
     * Update list of rule columns for user.
     */
    async updateListOfRuleColumnsRaw(requestParameters: UpdateListOfRuleColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListOfRuleColumns.');
        }

        if (requestParameters.apiUserColumnsRequest === null || requestParameters.apiUserColumnsRequest === undefined) {
            throw new runtime.RequiredError('apiUserColumnsRequest','Required parameter requestParameters.apiUserColumnsRequest was null or undefined when calling updateListOfRuleColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/ruleColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserColumnsRequestToJSON(requestParameters.apiUserColumnsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update list of rule columns for user.
     */
    async updateListOfRuleColumns(requestParameters: UpdateListOfRuleColumnsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateListOfRuleColumnsRaw(requestParameters, initOverrides);
    }

    /**
     * Update list of stbgroup columns for user.
     */
    async updateListOfStbgroupColumnsRaw(requestParameters: UpdateListOfStbgroupColumnsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListOfStbgroupColumns.');
        }

        if (requestParameters.apiUserColumnsRequest === null || requestParameters.apiUserColumnsRequest === undefined) {
            throw new runtime.RequiredError('apiUserColumnsRequest','Required parameter requestParameters.apiUserColumnsRequest was null or undefined when calling updateListOfStbgroupColumns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/stbgroupColumns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserColumnsRequestToJSON(requestParameters.apiUserColumnsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update list of stbgroup columns for user.
     */
    async updateListOfStbgroupColumns(requestParameters: UpdateListOfStbgroupColumnsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateListOfStbgroupColumnsRaw(requestParameters, initOverrides);
    }

    /**
     * Update user by ID.
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUser.');
        }

        if (requestParameters.userRequest === null || requestParameters.userRequest === undefined) {
            throw new runtime.RequiredError('userRequest','Required parameter requestParameters.userRequest was null or undefined when calling updateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserRequestToJSON(requestParameters.userRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user by ID.
     */
    async updateUser(requestParameters: UpdateUserRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateUserRaw(requestParameters, initOverrides);
    }

    /**
     * Update user isLocked flag by ID.
     */
    async updateUserIsLockedRaw(requestParameters: UpdateUserIsLockedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserIsLocked.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateUserIsLocked.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{id}/isLocked`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user isLocked flag by ID.
     */
    async updateUserIsLocked(requestParameters: UpdateUserIsLockedRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateUserIsLockedRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ReadUsersDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
